import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field} from "formik";
import * as Yup from "yup";
import routes from "../../../routes/configurationAdmin.routes";
// Service
import api from "../../../service/api";
// Components
import Header from "../../../components/Header";
import Dropzone from "../../../components/Dropzone";
import Button from "../../../components/Button";
import { Container, RowForInput, TitleField, ContainerDropzone, Title, Info, EstablishmentSelected} from "./styles";
import NavTabs from "../../../components/NavTabs";
import { ToastContainer } from "react-toastify";
//Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";

const Documents = () => {
    const login = useSelector((state: {login: any}) => state.login);
    const { establishment } = useSelector((state: {establishment: any}) => state.establishment);
    const history = useHistory();
    const [messageError, setMessageError] = useState("")
    const [addMessageError, setAddMessageError] = useState(false);
    const [selectedFileDocument, setSelectedFileDocument] = useState<File>();
    const [selectedFileResidence, setSelectedFileResidence] = useState<File>();
    const [selectedFileActivity, setSelectedFileActivity] = useState<File>();
    const [selectedFileCnpj, setSelectedFileCnpj] = useState<File>();
    
    useEffect(() => {
        if(login.user.groups.mc6 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const postIdentification = async () => {
        toastCreate("identification", "info" , 1500, "Carregando...");
        const doc = new FormData();
        let err = ""
        
        try {
          if(selectedFileDocument) {
            doc.append("filename" , selectedFileDocument);
            const res = await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${establishment?.sellerOwnerPayId}&category=identificacao`, 
            doc);
            
            if(res.status === 404){
              err = "Falha ao enviar a identificação, tente novamente ou entre em contato com o suporte."
              throw new Error("Falha ao enviar a identificação, tente novamente ou entre em contate com o suporte.")
            }
            
            if(res.status === 413){
              err = "Tamanho do arquivo é maior do que o permitido. Tamanho máximo: 1Mb."
              throw new Error("Tamanho do arquivo grande demais, tente outro.")
            }
            
            showError(false);
            toastUpdate("identification", "success" , 3000, "Documento de identificação enviado")
          }
        } catch (e) {
          showError(true, err.length !== 0 ? err : "Falha ao enviar identificação, tente novamente ou contate o suporte.");
          toastUpdate("identification", "error" , 3000,  err.length !== 0 ? err : "Falha ao enviar identificação")
        }
      }

      const showError = (show: boolean, error?: string ) => {
        if(show){
          setMessageError(error as string);
          
          return setAddMessageError(true);
        } 
        
        else {
          setMessageError("");
          
          return setAddMessageError(false);
        }
      }
    
      const postResidence = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const resi = new FormData();
        let err = "";
        
        try {
          if(selectedFileResidence) {
            resi.append("filename" , selectedFileResidence);
            
            const res = await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${establishment?.sellerOwnerPayId}&category=residencia`, 
            resi);

            if(res.status === 404){
              err = "Falha ao enviar a residência, tente novamente ou entre em contato com o suporte."
              throw new Error("Falha ao enviar a identificação, tente novamente ou entre em contate com o suporte.")
            }
            
            if(res.status === 413){
              err = "Tamanho do arquivo é maior do que o permitido. Tamanho máximo: 1Mb."
              throw new Error("Tamanho do arquivo grande demais, tente outro.")
            }
            
            toastUpdate("submit", "success" , 3000, "Documento de residência enviado")
          }
          
          showError(false);
        } catch (error) {
          showError(true, err.length !== 0 ? err : "Falha ao enviar residência, tente novamente ou contate o suporte.");
          toastUpdate("submit", "error" , 3000, err.length !== 0 ? err : "Falha ao enviar residência")
        }
      }
      
      const postActivity = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const act = new FormData();
        let err = "";
        
        try {
          if(selectedFileActivity) {
            act.append("filename" , selectedFileActivity);
            const res = await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${establishment?.sellerOwnerPayId}&category=atividade`, 
            act);
            
            if(res.status === 404){
              err = "Falha ao enviar a atividade, tente novamente ou entre em contato com o suporte."
              throw new Error("Falha ao enviar a identificação, tente novamente ou entre em contate com o suporte.")
            }
            
            if(res.status === 413){
              err = "Tamanho do arquivo é maior do que o permitido. Tamanho máximo: 1Mb."
              throw new Error("Tamanho do arquivo grande demais, tente outro.")
            }
            toastUpdate("submit", "success" , 3000, "Documento de atividade enviado")
            showError(false)
          }
        } catch (error) {
          showError(true, err.length !== 0 ? err : "Falha ao enviar atividade, tente novamente ou contate o suporte.");
          toastUpdate("submit", "error" , 3000, err.length !== 0 ? err : "Falha ao enviar atividade")
        }
      }
    
      const postCnpj = async () => {
        toastCreate("submit", "info" , 1000, "Carregando...");
        const cnpj = new FormData();
        let err = ""
        
        try {
          if(selectedFileCnpj) {
            cnpj.append("filename" , selectedFileCnpj);
              const res = await api.patch(`/adm/ownerbranch/import/docs?sellerOwnerPayId=${establishment?.sellerOwnerPayId}&category=cnpj`, 
              cnpj);
              
              if(res.status === 404){
                err = "Falha ao enviar a CNPJ, tente novamente ou entre em contato com o suporte."
                throw new Error("Falha ao enviar a identificação, tente novamente ou entre em contate com o suporte.")
              }
              
              if(res.status === 413){
                err = "Tamanho do arquivo é maior do que o permitido. Tamanho máximo: 1Mb."
                throw new Error("Tamanho do arquivo grande demais, tente outro.")
              }
              toastUpdate("submit", "success" , 3000, "Documento de CNPJ enviado")
              showError(false);
            }
          } catch (error) {
          showError(true, err.length !== 0 ? err : "Falha ao enviar CNPJ, tente novamente ou contate o suporte.");
          toastUpdate("submit", "error" , 3000, err.length !== 0 ? err : "Falha ao enviar CNPJ")
        }
      }
    
      return(
        <div>
            <ToastContainer/>
            <Header title="Documentos" subTitle="Adicione documentos ao estabelecimento" subTitleWidth={239}/>
            <NavTabs tabs={routes}/>
            <TitleField>
              Estabelecimento selecionado: 
              <EstablishmentSelected>
                  {` ${establishment.businessName ?? "nenhum, selecione um no dashboard."}`} 
              </EstablishmentSelected>
            </TitleField>
            {
              Object.keys(establishment).length > 0
              ? <Formik
                initialValues={{}}
                onSubmit={async (values, {resetForm}) => {}}
              >
                {({}) => {
                  return(
                    <Container>
                      
                      <TitleField>Documentos</TitleField>
                      {
                        addMessageError
                        ? <p style={{color: "red"}}>{messageError}</p>
                        : null
                      }
                      <RowForInput>
                        <ContainerDropzone className="d-flex flex-column justify-content-between">
                          <Title className="mb-3" >Identificação</Title>
                          <Field id="document_file" name="document_file" type=".pdf" onFileUploaded={setSelectedFileDocument} as={Dropzone}/>
                          <Info className="my-3" >Documento (RG, CPF ou CNH) ou Cartão CNPJ (no caso de PJ).</Info>
                          <Button type="button" onClick={() => {postIdentification()}}> Enviar </Button>
                        </ContainerDropzone>
                        <ContainerDropzone className="d-flex flex-column justify-content-between">
                          <Title className="mb-3" >Residência</Title>
                          <Field id="residence_file" name="residence_file" type=".pdf" onFileUploaded={setSelectedFileResidence} as={Dropzone}/>
                          <Info className="my-3" >Conta de luz, telefone ou gás no nome do proprietário ou de familiares.</Info>
                          <Button  type="button" onClick={() => {postResidence()}} > Enviar </Button>
                        </ContainerDropzone>
                      </RowForInput>

                      <RowForInput>
                        <ContainerDropzone className="d-flex flex-column justify-content-between">
                          <Title className="mb-3" >Atividade</Title>
                          <Field id="activity_file" name="activity_file" type=".pdf" onFileUploaded={setSelectedFileActivity} as={Dropzone}/>
                          <Info className="my-3" >Alvará, nota fiscal de compras de produtos ou cartão de visitas do estabelecimento.</Info>
                          <Button  type="button" onClick={() => {postActivity()}} > Enviar </Button>
                        </ContainerDropzone>
                      {
                          establishment.ein !== null
                          ?
                          <ContainerDropzone className="d-flex flex-column justify-content-between">
                            <Title className="mb-3" > CNPJ </Title>
                            <Field id="activity_file" name="activity_file" type=".pdf" onFileUploaded={setSelectedFileCnpj} as={Dropzone}/>
                            <Info className="my-3" >Comprovante de Inscrição e de Situação Cadastral.</Info>
                            <Button type="button" onClick={() => {postCnpj()}} > Enviar </Button>
                          </ContainerDropzone>
                          : null
                      }
                      </RowForInput>
                    </Container>
                  )
                }}
              </Formik>
              : null
            }
        </div>
    )
}

export default Documents;